<script lang="ts">
    import FormsPage from '@Alternatives/Forms/Pages/FormsPage'
    export default FormsPage
</script>

<template>
    <div>
        <FormEditor :viewModel="formEditor" @save-form="handleFormEditorSave" />
        <FormDeleterDialog :viewModel="formDeleterDialog" @delete-form="handleDeleteFormCommand" />
        <FormDependenciesDialog :viewModel="formDependenciesDialog" />

        <PortfolioOrDecisionNavigation :workspaceId="workspaceId" :projectId="projectId" />

        <div class="container" style="margin-top: 80px; padding-top: 40px;">
            <div class="row">
                <div class="col-lg-6">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b; margin: 0;">Forms</h1>
                </div>
                <div class="col-lg-6 text-right">
                    <button class="btn btn-success" style="padding: 0.7em 2em;" @click="showFormCreator">
                        Create form
                    </button>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 60px;" />

        <div class="container" v-if="rm">
            <div class="row">
                <div class="col-lg-4 offset-lg-8">
                    <div class="input-group input-group-lg">
                        <input type="search" placeholder="Search" class="form-control" v-model="SearchPhrase">
                        <span class="input-group-append"><span class="input-group-text"><i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i></span></span>
                    </div>
                </div>
            </div>

            <table class="table table-bordered table-hover table-browser mt-3">
                <thead>
                    <tr>
                        <th class="sortable" @click="orderByName()" :class="{ 'selected': OrderBy === 'name' }">
                            <span class="text-uppercase font-weight-normal">Name</span>

                            <span class="fa-stack">
                                <i class="fa fa-sort-asc fa-stack-1x" :class="{ 'selected': OrderBy === 'name' && OrderByDescending === false }"></i>
                                <i class="fa fa-sort-desc fa-stack-1x" :class="{ 'selected': OrderBy === 'name' && OrderByDescending === true }"></i>
                            </span>
                        </th>
                        <th class="sortable text-center" style="width: 180px;" @click="orderByModified()" :class="{ 'selected': OrderBy === 'modified' }">

                            <span class="text-uppercase font-weight-normal">Updated on</span>

                            <span class="fa-stack">
                                <i class="fa fa-sort-asc fa-stack-1x" :class="{ 'selected': OrderBy === 'modified' && OrderByDescending === false }"></i>
                                <i class="fa fa-sort-desc fa-stack-1x" :class="{ 'selected': OrderBy === 'modified' && OrderByDescending === true }"></i>
                            </span>
                        </th>
                        <th class="sortable text-center" style="width: 180px;" @click="orderByCreated()" :class="{ 'selected': OrderBy === 'created' }">

                            <span class="text-uppercase font-weight-normal">Created on</span>

                            <span class="fa-stack">
                                <i class="fa fa-sort-asc fa-stack-1x" :class="{ 'selected': OrderBy === 'created' && OrderByDescending === false }"></i>
                                <i class="fa fa-sort-desc fa-stack-1x" :class="{ 'selected': OrderBy === 'created' && OrderByDescending === true }"></i>
                            </span>
                        </th>
                        <th style="width: 90px;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="f in formsView" :key="f.Id">
                        <td>
                            <a class="text-dark" v-sanitizedHref="url_EditFormPage(f.Id)">{{f.Name}}</a>
                        </td>
                        <td class="text-center">
                            <span>{{getFormattedDateStr(f.Modified)}}</span><br />
                            <small>{{getFormattedTimeStr(f.Modified)}}</small>
                        </td>
                        <td class="text-center">
                            <span>{{getFormattedDateStr(f.Created)}}</span><br />
                            <small>{{getFormattedTimeStr(f.Created)}}</small>
                        </td>
                        <td>
                            <div class="dropdown">
                                <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    Actions
                                </button>
                                <div class="dropdown-menu dropdown-menu-right">
                                    <a class="dropdown-item" @click="showFormEditor(f)">Rename</a>
                                    <a class="dropdown-item" v-sanitizedHref="url_EditFormPage(f.Id)">Edit</a>
                                    <a class="dropdown-item" @click="showFormCloner(f)">Clone</a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" @click="showFormDependenciesViewer(f)">View dependencies</a>
                                    <div class="dropdown-divider"></div>
                                    <a class="dropdown-item" @click="showFormDeleter(f)">Delete</a>
                                </div>
                            </div>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>


    </div>
</template>

<style scoped>

</style>


